// import React, { useRef, useState, useEffect } from "react";
// import {
//   Layout,
//   Card,
//   Typography,
//   Input,
//   Button,
//   Space,
//   Tag,
//   Row,
//   Col,
//   Avatar,
//   Spin,
// } from "antd";

// import {
//   RobotOutlined,
//   SendOutlined,
//   RiseOutlined,
//   WarningOutlined,
//   ThunderboltOutlined,
//   UserOutlined,
// } from "@ant-design/icons";

// const { Text, Title } = Typography;

// const suggestions = [
//   "How can I improve my Lincfolio score?",
//   "Why is my win rate low?",
//   "Analyze my risk management",
//   "How to increase profit factor?",
// ];

// export default function TradingAIChatbot() {
//   const [messages, setMessages] = useState([
//     {
//       role: "ai",
//       text: "Hi 👋 I’m your AI Trading Coach. Ask me anything about your trading performance and score improvement.",
//     },
//   ]);

//   const [input, setInput] = useState("");
//   const [loading, setLoading] = useState(false);

//   const chatRef = useRef(null);

//   useEffect(() => {
//     if (chatRef.current) {
//       chatRef.current.scrollTop = chatRef.current.scrollHeight;
//     }
//   }, [messages]);

//   const sendMessage = async (customText) => {
//     const finalText = customText || input;

//     if (!finalText.trim()) return;

//     const userMessage = {
//       role: "user",
//       text: finalText,
//     };

//     setMessages((prev) => [...prev, userMessage]);
//     setInput("");
//     setLoading(true);

//     try {
//       // 🔥 Backend API
//       const res = await fetch("http://localhost:8000/api/chat", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },

//         body: JSON.stringify({
//           question: finalText,

//           analytics: {
//             score: 300,
//             pnl: -2500,
//             winRate: 42,
//             profitFactor: 1.1,
//           },
//         }),
//       });

//       const data = await res.json();

//       setMessages((prev) => [
//         ...prev,
//         {
//           role: "ai",
//           text:
//             data?.reply ||
//             "You should improve risk management and avoid overtrading.",
//         },
//       ]);
//     } catch (error) {
//       setMessages((prev) => [
//         ...prev,
//         {
//           role: "ai",
//           text: "AI server connection failed.",
//         },
//       ]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Card
//       bordered={false}
//       style={{
//         borderRadius: 20,
//         overflow: "hidden",
//       }}
//       bodyStyle={{ padding: 0 }}
//     >
//       {/* HEADER */}
//       <div
//         style={{
//           padding: 20,
//           background: "linear-gradient(to right, #1677ff, #4096ff)",
//           color: "#fff",
//         }}
//       >
//         <Space align="start">
//           <Avatar
//             size={55}
//             icon={<RobotOutlined />}
//             style={{
//               background: "rgba(255,255,255,0.2)",
//             }}
//           />

//           <div>
//             <Title level={3} style={{ color: "#fff", margin: 0 }}>
//               AI Trading Coach
//             </Title>

//             <Text style={{ color: "#dbeafe" }}>
//               Improve your trading score with AI insights
//             </Text>
//           </div>
//         </Space>
//       </div>

//       {/* INSIGHTS */}
//       <div style={{ padding: 16, background: "#fafafa" }}>
//         <Row gutter={[16, 16]}>
//           <Col xs={24} md={8}>
//             <Card size="small">
//               <Space direction="vertical" size={2}>
//                 <Space>
//                   <RiseOutlined style={{ color: "#52c41a" }} />
//                   <Text strong>Profit Factor</Text>
//                 </Space>

//                 <Title level={4} style={{ margin: 0 }}>
//                   1.10
//                 </Title>

//                 <Text type="secondary">
//                   Target above 1.5 for stability
//                 </Text>
//               </Space>
//             </Card>
//           </Col>

//           <Col xs={24} md={8}>
//             <Card size="small">
//               <Space direction="vertical" size={2}>
//                 <Space>
//                   <WarningOutlined style={{ color: "#faad14" }} />
//                   <Text strong>Risk Warning</Text>
//                 </Space>

//                 <Text>
//                   Your average losses are bigger than profits.
//                 </Text>
//               </Space>
//             </Card>
//           </Col>

//           <Col xs={24} md={8}>
//             <Card size="small">
//               <Space direction="vertical" size={2}>
//                 <Space>
//                   <ThunderboltOutlined style={{ color: "#722ed1" }} />
//                   <Text strong>AI Suggestion</Text>
//                 </Space>

//                 <Text>
//                   Reduce overtrading and use fixed stop-loss.
//                 </Text>
//               </Space>
//             </Card>
//           </Col>
//         </Row>
//       </div>

//       {/* QUICK QUESTIONS */}
//       <div style={{ padding: "0 16px 16px" }}>
//         <Space wrap>
//           {suggestions.map((item) => (
//             <Tag
//               key={item}
//               color="blue"
//               style={{
//                 padding: "8px 14px",
//                 borderRadius: 30,
//                 cursor: "pointer",
//                 fontSize: 14,
//               }}
//               onClick={() => sendMessage(item)}
//             >
//               {item}
//             </Tag>
//           ))}
//         </Space>
//       </div>

//       {/* CHAT AREA */}
//       <div
//         ref={chatRef}
//         style={{
//           height: 450,
//           overflowY: "auto",
//           padding: 20,
//           background: "#f5f5f5",
//         }}
//       >
//         <Space direction="vertical" style={{ width: "100%" }} size={16}>
//           {messages.map((msg, index) => (
//             <div
//               key={index}
//               style={{
//                 display: "flex",
//                 justifyContent:
//                   msg.role === "user" ? "flex-end" : "flex-start",
//               }}
//             >
//               <div
//                 style={{
//                   maxWidth: "75%",
//                   background:
//                     msg.role === "user" ? "#1677ff" : "#fff",
//                   color:
//                     msg.role === "user" ? "#fff" : "#000",
//                   padding: "12px 16px",
//                   borderRadius: 18,
//                   boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
//                 }}
//               >
//                 <Space align="start">
//                   {msg.role === "ai" ? (
//                     <Avatar
//                       size="small"
//                       icon={<RobotOutlined />}
//                     />
//                   ) : (
//                     <Avatar
//                       size="small"
//                       icon={<UserOutlined />}
//                     />
//                   )}

//                   <Text
//                     style={{
//                       color:
//                         msg.role === "user"
//                           ? "#fff"
//                           : "#000",
//                     }}
//                   >
//                     {msg.text}
//                   </Text>
//                 </Space>
//               </div>
//             </div>
//           ))}

//           {loading && (
//             <Card
//               size="small"
//               style={{
//                 width: 220,
//                 borderRadius: 14,
//               }}
//             >
//               <Space>
//                 <Spin size="small" />
//                 <Text>AI analyzing trades...</Text>
//               </Space>
//             </Card>
//           )}
//         </Space>
//       </div>

//       {/* INPUT */}
//       <div
//         style={{
//           padding: 16,
//           borderTop: "1px solid #f0f0f0",
//           background: "#fff",
//         }}
//       >
//         <Space.Compact style={{ width: "100%" }}>
//           <Input
//             size="large"
//             placeholder="Ask AI about your trading performance..."
//             value={input}
//             onChange={(e) => setInput(e.target.value)}
//             onPressEnter={() => sendMessage()}
//           />

//           <Button
//             type="primary"
//             size="large"
//             icon={<SendOutlined />}
//             loading={loading}
//             onClick={() => sendMessage()}
//           >
//             Send
//           </Button>
//         </Space.Compact>
//       </div>
//     </Card>
//   );
// }


import React, { useRef, useState, useEffect } from "react";

import {
  Card,
  Typography,
  Input,
  Button,
  Space,
  Tag,
  Row,
  Col,
  Avatar,
  Spin,
  message,
} from "antd";

import {
  RobotOutlined,
  SendOutlined,
  RiseOutlined,
  WarningOutlined,
  ThunderboltOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useChatBotMutation } from "../slices/usersApiSlice";
import { useSelector } from "react-redux";

// import { useChatBotMutation";

const { Text, Title } = Typography;

const suggestions = [
  "How can I improve my trading score?",
  "Why is my win rate low?",
  "Analyze my risk management",
  "How to increase profit factor?",
];

export default function TradingAIChatbot() {

  const [chatBot] = useChatBotMutation();
const { date } = useSelector((state) => state.date);

  const [messages, setMessages] = useState([
    {
      role: "ai",
      text: "Hi 👋 I’m your AI Trading Coach.",
    },
  ]);

  const [input, setInput] = useState("");

  const [loading, setLoading] = useState(false);

  const chatRef = useRef(null);

  // =========================
  // AUTO SCROLL
  // =========================
  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop =
        chatRef.current.scrollHeight;
    }
  }, [messages]);

  // =========================
  // SEND MESSAGE
  // =========================
  const sendMessage = async (customText) => {

  const finalText = customText || input;

  if (!finalText.trim()) return;

  const userMessage = {
    role: "user",
    text: finalText,
  };

  setMessages((prev) => [...prev, userMessage]);

  setInput("");

  setLoading(true);

  try {

    const response = await chatBot({

      question: finalText,

      startDate: date.startDate,

      endDate: date.endDate,

    }).unwrap();

    setMessages((prev) => [
      ...prev,
      {
        role: "ai",
        text:
          response?.reply ||
          "AI could not analyze trades.",
      },
    ]);

  } catch (error) {

    console.log("CHATBOT ERROR:", error);

    setMessages((prev) => [
      ...prev,
      {
        role: "ai",
        text: "AI server connection failed.",
      },
    ]);

  } finally {

    setLoading(false);

  }
};
  return (
    <Card
      bordered={false}
      style={{
        borderRadius: 20,
        overflow: "hidden",
      }}
      bodyStyle={{
        padding: 0,
      }}
    >

      {/* ================= HEADER ================= */}

      <div
        style={{
          padding: 20,
          background:
            "linear-gradient(to right, #1677ff, #4096ff)",
          color: "#fff",
        }}
      >
        <Space align="start">

          <Avatar
            size={55}
            icon={<RobotOutlined />}
            style={{
              background:
                "rgba(255,255,255,0.2)",
            }}
          />

          <div>

            <Title
              level={3}
              style={{
                color: "#fff",
                margin: 0,
              }}
            >
              AI Trading Coach
            </Title>

            <Text
              style={{
                color: "#dbeafe",
              }}
            >
              Analyze your broker trades using AI
            </Text>

          </div>
        </Space>
      </div>

      {/* ================= INSIGHTS ================= */}

      <div
        style={{
          padding: 16,
          background: "#fafafa",
        }}
      >
        <Row gutter={[16, 16]}>

          <Col xs={24} md={8}>
            <Card size="small">

              <Space direction="vertical">

                <Space>
                  <RiseOutlined
                    style={{
                      color: "#52c41a",
                    }}
                  />

                  <Text strong>
                    Profit Factor
                  </Text>
                </Space>

                <Title
                  level={4}
                  style={{
                    margin: 0,
                  }}
                >
                  1.10
                </Title>

                <Text type="secondary">
                  Target above 1.5
                </Text>

              </Space>
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card size="small">

              <Space direction="vertical">

                <Space>
                  <WarningOutlined
                    style={{
                      color: "#faad14",
                    }}
                  />

                  <Text strong>
                    Risk Warning
                  </Text>
                </Space>

                <Text>
                  Losses are bigger than wins.
                </Text>

              </Space>
            </Card>
          </Col>

          <Col xs={24} md={8}>
            <Card size="small">

              <Space direction="vertical">

                <Space>
                  <ThunderboltOutlined
                    style={{
                      color: "#722ed1",
                    }}
                  />

                  <Text strong>
                    AI Suggestion
                  </Text>
                </Space>

                <Text>
                  Reduce overtrading.
                </Text>

              </Space>
            </Card>
          </Col>

        </Row>
      </div>

      {/* ================= QUICK QUESTIONS ================= */}

      <div style={{ padding: 16 }}>

        <Space wrap>

          {suggestions.map((item) => (

            <Tag
              key={item}
              color="blue"
              style={{
                padding: "8px 14px",
                borderRadius: 30,
                cursor: "pointer",
              }}
              onClick={() =>
                sendMessage(item)
              }
            >
              {item}
            </Tag>

          ))}

        </Space>

      </div>

      {/* ================= CHAT AREA ================= */}

      <div
        ref={chatRef}
        style={{
          height: 450,
          overflowY: "auto",
          padding: 20,
          background: "#f5f5f5",
        }}
      >

        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
          size={16}
        >

          {messages.map((msg, index) => (

            <div
              key={index}
              style={{
                display: "flex",
                justifyContent:
                  msg.role === "user"
                    ? "flex-end"
                    : "flex-start",
              }}
            >

              <div
                style={{
                  maxWidth: "75%",
                  background:
                    msg.role === "user"
                      ? "#1677ff"
                      : "#fff",

                  color:
                    msg.role === "user"
                      ? "#fff"
                      : "#000",

                  padding: "12px 16px",

                  borderRadius: 18,

                  boxShadow:
                    "0 2px 8px rgba(0,0,0,0.06)",
                }}
              >

                <Space align="start">

                  <Avatar
                    size="small"
                    icon={
                      msg.role === "ai"
                        ? <RobotOutlined />
                        : <UserOutlined />
                    }
                  />

                  <Text
                    style={{
                      color:
                        msg.role === "user"
                          ? "#fff"
                          : "#000",
                    }}
                  >
                    {msg.text}
                  </Text>

                </Space>

              </div>

            </div>

          ))}

          {loading && (

            <Card
              size="small"
              style={{
                width: 240,
              }}
            >
              <Space>
                <Spin size="small" />
                <Text>
                  AI analyzing broker trades...
                </Text>
              </Space>
            </Card>

          )}

        </Space>
      </div>

      {/* ================= INPUT ================= */}

      <div
        style={{
          padding: 16,
          borderTop:
            "1px solid #f0f0f0",
        }}
      >

        <Space.Compact
          style={{
            width: "100%",
          }}
        >

          <Input
            size="large"
            placeholder="Ask AI about your trading..."
            value={input}
            onChange={(e) =>
              setInput(e.target.value)
            }
            onPressEnter={() =>
              sendMessage()
            }
          />

          <Button
            type="primary"
            size="large"
            icon={<SendOutlined />}
            loading={loading}
            onClick={() =>
              sendMessage()
            }
          >
            Send
          </Button>

        </Space.Compact>

      </div>

    </Card>
  );
}